import React, { useState, useEffect } from "react";
import {
  Paper,
  Stepper,
  Step,
  StepLabel,
  Typography,
  CircularProgress,
  CssBaseline,
  Divider,
  Button,
} from "@material-ui/core";
//
// import DoneIcon from "@mui/icons-material/Done";
import DoneIcon from "@material-ui/icons/Done";

import { Link, useHistory } from "react-router-dom";

//STYLES ---------
import useStyles from "./styles";
//

//
import { commerce } from "../../../lib/commerce";
//
import AddressForm from "../AddressForm";
import PaymentForm from "../PaymentForm";
//
// Stepper 2.
const steps = ["Shipping address", "Payment details"];

//
//

const Checkout = ({ cart, onCaptureCheckout, order, error }) => {
  //
  //----------- new state related to the token ---
  const [checkoutToken, setCheckoutToken] = useState(null);
  //
  //----------- Here we will create the TOKEN -----
  const [activeStep, setActiveStep] = useState(0);

  //----------- Here we will create the TOKEN -----
  //

  //
  // All the shipping data(countries,subDivs,options) will pass through this below
  const [shippingData, setShippingData] = useState({});
  //
  // related to the time out Spinner, which is
  // connected to the function that nests the 'history'
  // const [isFinished, setIsFinished] = useState(false);// related to mimic no card in commercejs
  //
  //
  const classes = useStyles();
  // related to the cart error at the very end of the project
  const history = useHistory();
  /*
  
  
  
  
  
  
  
  
  
  */
  const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep + 1);
  const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

  /*

  */

  useEffect(() => {
    if (cart.id) {
      const generateToken = async () => {
        try {
          const token = await commerce.checkout.generateToken(cart.id, {
            type: "cart",
          });
          setCheckoutToken(token);
        } catch (error) {
          // So if there is an error,
          // we push you back to the home page
          // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
          // if (activeStep !== steps.length) history.push("/");
          if (activeStep !== steps.length) history.push("/");
        }
      };

      generateToken();
    }
  }, [cart, activeStep, history]);
  //
  //
  /*
  
  
  
  */

  // we are going to pass this function
  //  as PROPS to our AddressForm.jsx
  // Of course the function is going to accept the 'data'
  // So what are we going to do with that 'data
  const next = (data) => {
    setShippingData(data);
    //
    nextStep();
  };

  //
  //
  //
  let Confirmation = () =>
    order.customer ? (
      <>
        <div>
          <Typography variant="h5">
            Thank you for your purchase, {order.customer.firstname}{" "}
            {order.customer.lastname}!
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="subtitle2">
            Order ref: {order.customer_reference}
          </Typography>
        </div>
        <br />

        {/* 
        
        BUTTON
        */}
        <Button component={Link} variant="outlined" type="button" to="/">
          Back to home
        </Button>
      </>
    ) : (
      // while the order and the data is being checked
      // we will show an spinner, once it s done the spinner
      // will vanish and we will have perhaps the success or error

      <div className={classes.spinner}>
        <CircularProgress />
      </div>
    );
  //
  //

  // Related to the errors, in case something
  // goes wrong with the order confirmation
  //
  //
  if (error) {
    <>
      <Typography variant="h5">Error: {error}</Typography>
      <br />
      <Button component={Link} variant="outlined" type="button" to="/">
        Back to home
      </Button>
    </>;
  }

  //
  //
  //
  const Form = () =>
    activeStep === 0 ? (
      <AddressForm
        checkoutToken={checkoutToken}
        nextStep={nextStep}
        setShippingData={setShippingData}
        next={next}
      />
    ) : (
      <PaymentForm
        checkoutToken={checkoutToken}
        nextStep={nextStep}
        backStep={backStep}
        shippingData={shippingData}
        onCaptureCheckout={onCaptureCheckout}
        // spinner props to be send to PaymentForm.jsx
        //timeout={timeout}
      />
    );
  //
  //
  //
  return (
    <>
      <CssBaseline /> {/* <div className={classes.toolbar} /> */}
      <main className={classes.layoutWrapper}>
        <div
          className={classes.containerFormCheckout}
          //  style={{ background: "peru" }}
        >
          {" "}
          <Paper
            className={classes.paper}
            style={{
              fontSize: "1rem",
              fontFamily: "Syncopate-Bold",
              color: "#121212",
              textTransform: "uppercase",
              fontWeight: "100",
            }}
          >
            <Typography variant="h4" align="center">
              Checkout
            </Typography>
            {/* 
          
          STEPPER
          
          */}
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel icon={<DoneIcon />} className={classes.stepLabel}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            {/*  */}

            {activeStep === steps.length ? (
              <Confirmation />
            ) : (
              checkoutToken && <Form />
            )}
          </Paper>
        </div>
      </main>
    </>
  );
};

export default Checkout;
